<div>
  <div *ngFor="let message of visibleMessages">
    <app-alert [type]="message.type">{{ message.value | translate}} {{ message.message | translate }}</app-alert>
  </div>
</div>
